import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Stop scroll on render
 * @returns null
 */
export function ScrollToTopOnReload() { //Scroll on top on page render/reload
    const location = useLocation();
    
    useEffect(() => { //Will render on location change or reload
        window.scrollTo(0, 0);
    }, [location]);

    return null;
};

/**
 * Enable/Disable scrolling
 * @param preference change scroll state
 */
export function preventScroll(preference: boolean) {
    if (preference) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "scroll";
    };
};